/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable max-len */

/**
 * WARNING: Do not include this file in client build.
 */
const DO_NOT_USE_THIS_FILE_IN_CLIENT = `
Configuration file contains sensitive information and
MUST NOT be included in the client build.
`;

if (process.env.BROWSER) {
    alert(DO_NOT_USE_THIS_FILE_IN_CLIENT); // eslint-disable-line no-alert
    throw new Error(DO_NOT_USE_THIS_FILE_IN_CLIENT);
}

export const port = process.env.PORT || 80;
export const host = process.env.WEBSITE_HOSTNAME || `184.107.18.100:${port}`;
export const listeningIp = '184.107.18.100';

export const databaseUrl = process.env.DATABASE_URL || 'sqlite:database.sqlite';

export const analytics = {

    // https://analytics.google.com/
    google: { trackingId: process.env.GOOGLE_TRACKING_ID || 'UA-89905123-1' },

};

export const auth = {

    jwt: { secret: process.env.JWT_SECRET || 'Agence Prolifik' },

    // https://developers.facebook.com/
    facebook: {
        id: process.env.FACEBOOK_APP_ID || '1889415974626086',
        secret: process.env.FACEBOOK_APP_SECRET || 'a970ae3240ab4b9b8aae0f9f0661c6fc',
    },

    // https://cloud.google.com/console/project
    google: {
        id: process.env.GOOGLE_CLIENT_ID || '251410730550-ahcg0ou5mgfhl8hlui1urru7jn5s12km.apps.googleusercontent.com',
        secret: process.env.GOOGLE_CLIENT_SECRET || 'Y8yR9yZAhm9jQ8FKAL8QIEcd',
    },

    // https://apps.twitter.com/
    twitter: {
        key: process.env.TWITTER_CONSUMER_KEY || 'Ie20AZvLJI2lQD5Dsgxgjauns',
        secret: process.env.TWITTER_CONSUMER_SECRET || 'KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ',
    },

};



// WEBPACK FOOTER //
// ./config.js